import { SB } from '@play-co/replicant';

/**
 * Type for resurrection schema
 */
export type ResurrectionSchema = NonNullable<
  SB.ExtractType<typeof resurrectionSchema.resurrection>
>;

/**
 * Type for valid resurrection reward items - the properties defined in the schema
 */
export type ResurrectionReward = keyof ResurrectionSchema;

export const resurrectionSchema = {
  // Resurrect timestamps set when the OA messages are delivered
  resurrection: SB.object({
    // Timestamp of when user receives a revive-pet message
    revivePet: SB.number().optional(),
    // Timestamp of when user receives gems reward message
    hundredGems: SB.number().optional(),
    // Timestamp of when user receives migration ToS incentive gems reward message
    migrationGems: SB.number().optional(),
    // Timestamp of when user receives the 50-gem bear apology OA
    fiftyGemsBear: SB.number().optional(),
    // Timestamp of when user receives the 50-gem bear+capybara apology OA
    fiftyGemsBearCapy: SB.number().optional(),
  }).optional(),
};
